<template>
  <div class="data-preview-container">
    <div class="data-title">
      <div
        class="data-preview-header-left"
        style="color: #333333;padding:15px 25px 0 25px"
      >
        预览
      </div>
    </div>
    <div class="data-preview-header">
      <div class="data-preview-header-left">
        <span style="color:#2A7EE3">{{ data.name }} </span>
      </div>
      <div class="data-preview-header-right">
        <el-button
          v-if="showMap == false"
          @click="showMap = true"
          type="primary"
          >数据可视化</el-button
        >
        <el-button v-else @click="showMap = false" type="primary"
          >返回</el-button
        >
      </div>
    </div>

    <div class="data-preview-info-detail">
      <div class="data-preview-header-left">
        <span>{{ data.title }} </span>
      </div>
      <div class="data-preview-header-right">
        <span style="display:flex"
          >数据提供单位：
          <p>{{ data.companyName }}</p></span
        >
        <span style="display:flex"
          >最后更新时间：
          <p>{{ data.lastUpdateTime }}</p></span
        >
      </div>
    </div>

    <div class="data-preview-info-box" v-if="showMap == false">
      <el-table
        v-if="tableData.length != 0"
        :data="tableData"
        border=""
        style="width: 100%"
      >
        <el-table-column
          align="center"
          v-for="(item, index) in tableData[0]"
          :key="index"
          :prop="index"
          :label="index"
        />
      </el-table>
      <view v-else>
        <span class="el-table__empty-text">暂无数据</span>
      </view>
    </div>
    <div class="data-preview-info-box" v-if="showMap == true">
      <div
        v-if="tableData.length != 0"
        style="display:flex;width:100%;flex-direction: row;    justify-content: space-evenly;"
      >
        <el-card class="box-card" style="width:400px;height: 300px;">
          <template #header>
            <div class="card-header">
              <span>数据可视化</span>
            </div>
          </template>
          <el-form ref="form" :model="form" label-width="70px" required>
            <el-form-item label="图表类型" prop="type">
              <el-select v-model="form.type" placeholder="请选择图表类型">
                <el-option label="饼状图" value="pie"></el-option>
                <el-option label="柱状图" value="bar"></el-option>
                <el-option label="折线图" value="line"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="统计项" prop="dataItem" required>
              <el-select v-model="form.dataItem" placeholder="请选择统计项">
                <el-option
                  v-for="(item, index) in dataItemList"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="数据量" required>
              <el-select v-model="form.dataNum" placeholder="请选择图表类型">
                <el-option label="10" :value="10"></el-option>
                <el-option label="20" :value="20"></el-option>
                <el-option label="30" :value="30"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="creatForm('form')"
                >生成</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="box-card" style="width:740px;height:540px">
          <div class="box-chart">
            <div id="chart" class="chart" style="width:740px;height:540px" />
          </div>
        </el-card>
      </div>
      <view v-else>
        <span class="el-table__empty-text">暂无数据</span>
      </view>
    </div>
  </div>
</template>
<script>
import { getDataSetDetail, getDataview, getDataMpa } from "@/api/index";
import * as echarts from "echarts";
export default {
  data() {
    return {
      form: {
        id: "",
        dataNum: 10,
        dataItem: "",
        type: "pie"
      },
      dataItemList: [],
      // showMap: false,
      showMap: false,

      data: {},
      tableData: [],
      chart: null
    };
  },
  created() {
    
    this.init();
  },
  methods: {
    async init() {
      var data = await getDataSetDetail({ id: this.$route.params.id });
      this.data = data.result;
      var data1 = await getDataview({ id: this.$route.params.id });
      this.tableData = data1.result;
      // this.tableData = [
      //   {
      //     "负债合计": "823141.0",
      //     "流动负债合计": "285690.0",
      //     "应付账款": "44416.0",
      //     "所有者权益合计": "578801.0",
      //     "实收资本": "175500.0",
      //     "国家资本": "115500.0",
      //     "集体资本": ""
      //   }
      // ];
      if (this.tableData) {
        this.form.dataItem = Object.keys(this.tableData[0])[1];
      }
      // this.dataItemList = Object.keys(this.tableData[0]).slice(1, -1);
      this.dataItemList = Object.keys(this.tableData[0]);
      if (this.$route.query.type) {
        this.showMap = true;
      }
    },
    creatForm() {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }

      this.$refs["form"].validate(async valid => {
        if (valid) {
          this.form.id = this.data.id;
          var { result } = await getDataMpa(this.form);
          this.chart = echarts.init(document.getElementById("chart"));
          var xdata = [];
          var valueList = [];
          result.map(item => {
            xdata.push(item.name);
            valueList.push(item.value);
          });
          if (this.form.type != "pie") {
            var option = {
              xAxis: {
                type: "category",
                data: xdata
              },
              yAxis: {
                type: "value"
              },
              series: [
                {
                  data: valueList,
                  type: this.form.type
                }
              ]
            };
          } else {
            var option = {
              tooltip: {
                trigger: "item"
              },
              legend: {
                orient: "vertical",
                left: "left"
              },
              series: [
                {
                  type: "pie",
                  radius: "50%",
                  data: result,
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)"
                    }
                  }
                }
              ]
            };
          }

          this.chart.setOption(option);
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.data-preview-container {
  width: 100%;
  background: #ffffff;
  border: 1px solid #eeeeee;
  .data-comment-box {
    padding-bottom: 20px;
    .comment-list {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      margin-bottom: 30px;
      .comment-item {
        border-bottom: 1px dashed #e3e3e3;
        padding-bottom: 10px;
        > div {
          padding-left: 50px;
          margin-top: 10px;
          padding-right: 50px;
        }
        > div:last-child {
          font-size: 14px;
          font-weight: 400;
          color: #a1a1a1;
          line-height: 20px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }
      }
    }
    .comment-header {
      height: 50px;
      background: #2a7ee3;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-left: 50px;
    }
  }
  .data-preview-info-box {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 40px;
    min-height: 710px;
    .data-preview-info {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      line-height: 20px;
      width: 100%;
      height: 50px;
      background: #2a7ee3;
      > div {
        width: 150px;
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
      > div:first-child {
        background: #239dfc;
      }
    }
  }

  .data-preview-table {
    width: 100%;
    border-spacing: 0 !important;
    font-size: 13px;
    font-weight: 400;
    color: #333333;
    line-height: 18px;
    border-top: 1px solid #eeeeee;
    border-bottom: 1px solid #eeeeee;
    td {
      border-right: 1px solid #eeeeee;
      border-bottom: 1px solid #eeeeee;
      height: 36px;
      padding-left: 15px;
    }
    tbody > tr > td:last-child {
      border-right: none;
    }
    tbody > tr:nth-child(even) {
      background: rgba(240, 240, 240, 0.3);
    }
    .frist-td {
      padding-left: 50px !important;
      width: 100px !important;
    }
  }
  .data-preview-info-detail {
    .data-preview-header-left {
      color: #666666;
    }
    font-size: 13px;
    font-weight: 400;
    color: #666666;
    line-height: 18px;
    .data-preview-header-right {
      display: flex;
      flex-direction: row;
      span {
        margin-left: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        p {
          color: #2a7ee3;
        }
      }
    }
    font-size: 13px;
    font-weight: 400;
    color: #666666;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
    width: 90%;
    margin: 0 auto;
    padding: 0 45px 0 35px;
    background: #fafafa;
  }
  .data-preview-header {
    padding: 0 215px 0 25px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 500;
    color: #2a7ee3;
    line-height: 22px;

    > div {
      display: inherit;
      span {
        margin-right: 30px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
    }
    .data-preview-header-right {
      display: flex;
      flex-direction: row;
      span {
        margin-right: 0px;
        margin-left: 50px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
    }
  }
}
</style>
